import React from 'react'
import Text from '../../components/text/Text'
import {IProbeSuppressed} from './types'
import {formatProbeTime} from './utils'

interface IProps {
    className?: string
    items?: IProbeSuppressed[]
}

// action별로 무슨 일이 막힌 건지. probe는 진단이므로 sync 경로의 쓰기를 실행하지 않고 여기 적어둔다.
const ACTION_MEANING: Record<string, string> = {
    deactivate_key: '거래소가 자격증명을 거절했습니다. sync 경로였다면 키가 비활성화되고 유저에게 실패 알림이 나갔을 상황입니다.',
    update_key_fields: 'sync 경로가 기회 있을 때 갱신하는 키 필드(permission, ip_list, ip_status, account_id, exchange_info) 쓰기가 막혔습니다.',
}

// 리포트에서 대개 가장 정보량이 많은 구획이라 phase 표보다 위에 둔다.
const SuppressedWrites: React.FC<IProps> = ({className, items}) => {
    if (!items || items.length === 0) return null

    return (
        <div className={`bg-white rounded-[10px] p-[30px] shadow-normal ${className}`}>
            <Text className={'text-ti1 text-font01'}>Suppressed Writes ({items.length})</Text>
            <Text className={'text-body3 text-font03 mt-[4px]'}>
                probe가 막은 변경입니다. 경고가 아니라 진단 — sync 경로였다면 실제로 일어났을 일을 뜻합니다.
            </Text>

            <div className={'mt-[20px] space-y-[10px]'}>
                {items.map((item, idx) => (
                    <div
                        key={`${item.action}-${idx}`}
                        className={'rounded-[8px] border border-font_red bg-bg_red px-[16px] py-[12px]'}>
                        <div className={'flex items-center gap-x-[8px]'}>
                            <Text className={'text-ti2 text-font_red'}>{item.action}</Text>
                            {item.phase && <Text className={'text-body3 text-font03'}>({item.phase})</Text>}
                            <Text className={'text-body3 text-font03 ml-auto'}>{formatProbeTime(item.at)}</Text>
                        </div>
                        {item.reason && <Text className={'text-body2 text-font01 mt-[6px]'}>{item.reason}</Text>}
                        {ACTION_MEANING[item.action] && (
                            <Text className={'text-body3 text-font02 mt-[6px]'}>{ACTION_MEANING[item.action]}</Text>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default SuppressedWrites
